import { OfficeType as _OfficeType } from '../sdk/index'
import { OfficeType as IOfficeType } from '../sdk/interface'

export const OfficeType = _OfficeType as IOfficeType
